import commonConstant from "@/constants/commonConstant";
import { formatBalance } from "@/utils/common-utils";
import moment from "moment-timezone";
export const checkUserFromContract = (seedData) => {
    if (seedData) {
        console.log("checkUserFromContract", { seedData });
        // 0: balance
        // 1: hardCap
        // 2: seedPackage
        // 3: estReceiveMDN
        // 4: isWhitelisted
        // 5: isPurchased
        // 6: limitWhitelist: for all users
        return {
            isWinner: seedData[4],
            isPurchased: seedData[5],
        };
    }
};

/**
 * For display purpose
 * @param {*} allocation
 * @param {*} blockExplorerURL
 * @param {*} acceptCurrency
 * @returns
 */
export const getContributionReceipt = (allocation, blockExplorerURL, acceptCurrency) => {
    console.log("getContributionReceipt", allocation);
    const receiptDetails = [
        {
            title: "Transaction ID",
            value: allocation.txid,
            type: "tx",
            link: blockExplorerURL || "https://testnet.bscscan.com/",
            target: "_blank",
        },
        {
            title: "Your contribution",
            value:
                formatBalance(allocation.contributeValue).toLocaleString("en") +
                    " " +
                    acceptCurrency || "BUSD",
        },
        {
            title: "Token rate",
            value: allocation.tokenPrice + " USD",
        },
        {
            title: "Estimate Allocation",
            value: formatBalance(allocation.estimatedReceive).toLocaleString("en") + " MDN",
        },
    ];
    return {
        details: receiptDetails,
    };
};

/**
 * For display purpose
 * @param {*} vestingData
 * @returns
 */
export const getVestingScheduleDetails = (vestingData, claimTokenStart) => {
    const {
        totalTimes,
        tgeAllocation,
        totalAllocation,
        claimableStartAt,
        vestingDuration,
        tgeClaimed,
    } = vestingData;

    const details = [];
    let currentTime = new Date().getTime();
    let cliffDuration = vestingDuration / totalTimes;

    for (let i = 0; i < totalTimes + 1; ++i) {
        // Add TGE
        if (i == 0 && tgeAllocation > 0) {
            // tgeClaimed
            details.push({
                datetime: moment(claimTokenStart).format(
                    commonConstant.FORMAT_DATE_TIME_HMA_DMY
                ) + " (at TGE)",
                percent: (((tgeAllocation / totalAllocation) * 100 * 10) | 0) / 10 + "%",
                amount: ((tgeAllocation * 100) | 0) / 100,
                claimable: currentTime >= claimTokenStart?.valueOf() || 0, // IDO time
                claimed: tgeClaimed || false,
            });
        }
        // fisrt time
        let claimableTime = claimableStartAt * 1000 + i * cliffDuration * 1000;
        let item = {
            datetime: moment(claimableTime).format(commonConstant.FORMAT_DATE_TIME_HMA_DMY),
            percent: (((1 / totalTimes) * 100 * 10) | 0) / 10 + "%",
            amount: (((totalAllocation / totalTimes) * 100) | 0) / 100,
            claimable: currentTime >= claimableTime,
            claimed: false,
        };
        details.push(item);
    }
    console.log("getVestingScheduleDetails", details.length);
    return details;
};
